import { useEffect, useState, memo, useCallback } from "react";
import "./DividaExecutada.scss";

import PersonIcon from "@mui/icons-material/Person";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ListaDividaExecutada from "../listaDividaExecutada/ListaDividaExecutada";
import AjudaCard from "../../../../shared/components/ajudaCard/AjudaCard";

/**
 * Quanto os clientes devem pelo trabalho JÁ FEITO.
 *
 * Substituiu o widget de «pagamentos em atraso», que mostrava prestações cuja
 * data tinha passado. Isso é um facto de calendário: um cliente a meio do
 * tratamento com uma prestação atrasada paga na semana seguinte e não é problema
 * nenhum. Esta mostra a exposição real — trabalho entregue e não pago — que é o
 * dinheiro que a clínica pode mesmo perder.
 *
 * A dívida dos orçamentos e a dos tratamentos isolados vêm separadas do
 * servidor, e é assim que se mostram: são duas origens diferentes, e somá-las
 * tornava este número impossível de reconciliar com a ficha do cliente, que só
 * conta orçamentos.
 */
function DividaExecutada({ sendRequest, clinica, auth, estilo }) {
  const [dados, setDados] = useState();
  const [openModal, setOpenModal] = useState("");

  useEffect(() => {
    const fetchDivida = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/dividatrabalhoexecutado/${clinica.clinica._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );
        setDados(responseData);
      } catch (err) {}
    };
    fetchDivida();
  }, [auth.token, clinica.clinica._id, sendRequest]);

  const handleCloseModal = useCallback(() => {
    setOpenModal("");
  }, []);

  const formatar = (valor) => Math.round(valor || 0).toLocaleString("pt-Br");

  return (
    <div className={estilo ? estilo : ""}>
      <div className="dashboard-divida-executada__container">
        <span className="box-title box-title--com-ajuda">
          Trabalho por pagar
          <AjudaCard titulo="Como se calcula o trabalho por pagar">
            <p>
              <strong>Quanto os clientes devem por trabalho já feito.</strong>{" "}
              Não são prestações em atraso: é trabalho entregue e não pago.
            </p>
            <p>
              <strong>Orçamentos:</strong> os procedimentos marcados como
              executados no plano, ao preço do orçamento e já com o desconto
              aplicado, menos tudo o que foi pago nessa conta.
            </p>
            <p>
              <strong>Isolados:</strong> as entradas lançadas e ainda não
              recebidas de tratamentos isolados atendidos. Vêm separadas porque
              a ficha do cliente só conta orçamentos.
            </p>
            <p>
              <strong>Unidade:</strong> a dívida é da unidade que fez o
              orçamento, e os pagamentos abatem-na venham do balcão que vierem.
            </p>
            <p>
              <strong>Fora da conta:</strong> contas liquidadas, por aprovar ou
              interrompidas, e orçamentos e planos inativos.
            </p>
          </AjudaCard>
        </span>

        {dados && (
          <>
            <div className="dashboard-divida-executada__lucro-data">
              <span className="lucro lucro--red">
                <AttachMoneyIcon className="administrativoBottomContainers__debitosEmAtraso__twoDivs__element__iconText--icon" />
                {"  "}
                {formatar(dados.totais.dividaTotal)}
              </span>
              <span className="lucro-description">Executado e não pago</span>
            </div>

            <div className="dashboard-divida-executada__lucro-data">
              <span className="lucro">
                <PersonIcon className="administrativoBottomContainers__debitosEmAtraso__twoDivs__element__iconText--icon" />{" "}
                {dados.totais.totalClientes}
              </span>
              <span className="lucro-description">Clientes</span>
            </div>

            {/* As duas origens à vista. Sem isto, quem visse o total não sabia
                se vinha de planos de tratamento ou de trabalho solto — e são
                conversas diferentes a ter com o cliente. */}
            <div className="dashboard-divida-executada__origens">
              <span>
                Orçamentos{" "}
                <strong>{formatar(dados.totais.dividaOrcamentos)}</strong>
              </span>
              <span>
                Isolados <strong>{formatar(dados.totais.dividaIsolados)}</strong>
              </span>
            </div>
          </>
        )}

        <div
          className="button-more-div"
          onClick={() => setOpenModal("listaDivida")}
        >
          <span className="button-more">Mais</span>
          <span className="more-arrow"> {">"} </span>
        </div>
      </div>

      {/* `dados &&` porque o botão «Mais» está fora do bloco que espera pelos
          dados: clicar antes de a resposta chegar rebentava em `dados.clientes`.
          O widget antigo tem a mesma falha. */}
      {dados && openModal === "listaDivida" && (
        <ListaDividaExecutada
          open={openModal === "listaDivida"}
          data={dados.clientes}
          handleCloseModal={handleCloseModal}
        />
      )}
    </div>
  );
}

export default memo(DividaExecutada);
